import React, { useState } from 'react';
import { observer } from 'mobx-react';
import SimpleModal from '../../../../common/SimpleModal/SimpleModal';
const SingleCard = ({
  card,
  index,
  selectedCards,
  setSelectedCards,
  cardsToDelete
}) => {
  const selectCard = () => {
    if (cardsToDelete > 0 && !selectedCards.includes(index)) {
      setSelectedCards([...selectedCards, index]);
    } else if (selectedCards.includes(index)) {
      setSelectedCards(selectedCards.filter(e => e !== index));
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `single-card ${selectedCards.includes(index) ? 'selected' : ''}`,
    onClick: () => selectCard()
  }, card.title && card.title.startsWith('Card ') ? `Card ${index * 1 + 1}` : card.title), /*#__PURE__*/React.createElement("style", null, `.single-card.selected:before {
                background-image: url(${"https://objectstorage.eu-frankfurt-1.oraclecloud.com/n/fronf8xprl08/b/tecma-assets-coll/o" + '/CMS/img/icon/check.svg'})
            }`));
};
const RemoveTilesModal = observer(({
  open,
  handleClose,
  handleCancel,
  cards,
  targetNumber
}) => {
  const [selectedCards, setSelectedCards] = useState([]);
  const cardsToDelete = cards.length - targetNumber - selectedCards.length;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    onCancel: () => handleCancel(),
    showModal: open,
    title: "Attenzione",
    classes: {
      card: 'modal-remove-tiles'
    },
    subtitle: /*#__PURE__*/React.createElement(React.Fragment, null, "Stai sottraendo delle card gi\xE0 presenti nel layout.", /*#__PURE__*/React.createElement("br", null), "Quale card desideri eliminare?"),
    onSubmit: () => {
      handleClose(selectedCards);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-to-delete"
  }, "Card da eliminare: ", cardsToDelete), /*#__PURE__*/React.createElement("div", {
    className: "cards-container"
  }, cards.map((card, index) => {
    return /*#__PURE__*/React.createElement(SingleCard, {
      card: card,
      index: index,
      selectedCards: selectedCards,
      setSelectedCards: setSelectedCards,
      cardsToDelete: cardsToDelete
    });
  })))
  // <Modal open={open}>
  //   <div className='modal-content-container modal-remove-tiles'>

  //     <div className='modal-buttons-container'>
  //       <CMSButton className='button-annulla' inverted onClick={() => handleCancel()}>
  //         Annulla
  //       </CMSButton>

  //       <CMSButton disabled={cardsToDelete !== 0} className='button-crea' onClick={() => handleClose(selectedCards)}>
  //         Crea
  //       </CMSButton>
  //     </div>
  //   </div>
  // </Modal>
  ;
});

export default RemoveTilesModal;